import { useTrackMemberPortalSection } from '@/pages/member-portal/useTrackMemberPortalSection';
import { Outlet, createFileRoute } from '@tanstack/react-router';

function MemberPortalLayout() {
	useTrackMemberPortalSection();
	return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal')({
	component: MemberPortalLayout,
});
